/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountStatusResDto } from '../../models/account-status-res-dto';

export interface AccountsControllerFindManyAccountStatus$Params {}

export function accountsControllerFindManyAccountStatus(
  http: HttpClient,
  rootUrl: string,
  params?: AccountsControllerFindManyAccountStatus$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<Array<AccountStatusResDto>>> {
  const rb = new RequestBuilder(
    rootUrl,
    accountsControllerFindManyAccountStatus.PATH,
    'get',
  );
  if (params) {
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<AccountStatusResDto>>;
      }),
    );
}

accountsControllerFindManyAccountStatus.PATH = '/admin/accounts/status';
